module.exports = __webpack_public_path__ + "static/media/google.10c25a60.svg";